import { AuthUserModel } from "app/services/api/types/authorisation/models/AuthUserModel";
import { RootState } from "app/services/store";
import { FC, useMemo } from "react";
import { View } from "react-native";
import { useSelector } from "react-redux";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { EditIcon, TrashIcon } from "ui/gluestack/icon";
import { useResendUserInvite } from "../hooks/useResendUserInvite";

interface Props {
  user: AuthUserModel;
  onEdit?: (user: AuthUserModel) => void;
  onDelete?: (user: AuthUserModel) => void;
}

export const UserListActionButtons: FC<Props> = ({
  user,
  onEdit,
  onDelete,
}) => {
  const { handleResendUserInvite, isResending } = useResendUserInvite();

  const currentUser = useSelector(
    (state: RootState) => state.authorisation?.user,
  );
  const isCurrentUser = useMemo(() => {
    return currentUser?.id === user.id;
  }, [user]);

  return (
    <View className="flex flex-row self-end gap-x-2 md:gap-x-4">
      {user.edit_permission ? (
        <Button
          size="xs"
          variant="link"
          onPress={() => handleResendUserInvite(user)}
          className="px-2 xl:px-0"
          disabled={isResending}
        >
          <ButtonText className="hidden xl:block">Resend</ButtonText>
        </Button>
      ) : null}
      {onEdit && user.edit_permission ? (
        <Button
          size="xs"
          variant="link"
          onPress={() => onEdit(user)}
          className="px-2 xl:px-0"
        >
          <ButtonText className="hidden xl:block">Edit</ButtonText>

          <ButtonIcon as={EditIcon} />
        </Button>
      ) : null}
      {!isCurrentUser && onDelete && user.delete_permission ? (
        <>
          <Button
            size="xs"
            action="negative"
            variant="outline"
            onPress={() => onDelete(user)}
          >
            <ButtonText className="hidden xl:block">Delete</ButtonText>
            <ButtonIcon as={TrashIcon} />
          </Button>
        </>
      ) : null}
    </View>
  );
};
